import {useEffect, useState } from 'react';

import useAxiosPrivate from './useAxiosPrivate';
import useRole from './useRole';

const useStep = () => {
    // ? the will return the role intutule
    const axiosPrivate = useAxiosPrivate();
    const role = useRole();
    const [step,setStep]=useState('');

    const searchUserStep = async () => {
        if(role){
            try {
                const response = await axiosPrivate.get(`${role}/getMyInfos`);
                setStep(response?.data?.user?.completeStep);
            } catch (error) {
                console.log(error);
            }
        }
    };

    useEffect(() => {
        searchUserStep();
    }, [step, role]);

    return step;
};

export default useStep;